/**
 * Checks if the input string contains any symbolic text from specific writing systems.
 * Supported scripts include Hiragana, Katakana, Han (Chinese), Arabic, Thai, Hebrew, and Hangul (Korean).
 *
 * @example
 * hasSymbolicText('こんにちは'); // Returns true
 *
 * @example
 * hasSymbolicText('Hello'); // Returns false
 */
const hasSymbolicText = (text: string) =>
  /[\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Han}\p{Script=Arabic}\p{Script=Thai}\p{Script=Hebrew}\p{Script=Hangul}]/u.test(
    text
  );

export const softHyphen = '\u00AD';

/**
 * Inserts a soft hyphen (\u00AD) after every sequence of six consecutive letters.
 * This is useful for improving text wrapping in UI components where long words
 * or continuous strings may overflow or break the layout.
 * @example
 * getTextWithSoftHyphens('abcdefghij'); // Returns 'abcdef\u00ADghij'
 *
 * @example
 * getTextWithSoftHyphens('short'); // Returns 'short'
 */
export const getTextWithSoftHyphens = (text: string) => {
  if (hasSymbolicText(text)) {
    return text;
  }

  return text.replace(/(\p{L}{6})/gu, `$1${softHyphen}`);
};
